const getters = {

    sessionId: state => state.dialog.sessionId,
    sessionData: state => state.dialog.sessionData

}
export default getters
